import { IMetadata } from '@carm/_core';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { BaseState } from '../../models/base-state.model';
import * as MetadataActions from '../actions/metadata.actions';

export const metadataKey = 'carm-metadata';

export interface MetadataState extends EntityState<IMetadata>, BaseState {}

export const adapter: EntityAdapter<IMetadata> = createEntityAdapter<IMetadata>();

export const initialState: MetadataState = adapter.getInitialState({
  loading: false,
  success: false,
  error: null,
});

const Reducer = createReducer(
  initialState,
  on(MetadataActions.removeAllMetadata, (state) =>  adapter.removeAll({ ...state })),

  on(MetadataActions.loadAllMetadata, (state) => ({...state, loading: true })),

  on(MetadataActions.loadAllMetadataSuccess, (state, {data}) =>
          adapter.setAll(data, { ...state, success: true,
                                           loading: false,
                                           error: null })),

  on(MetadataActions.loadAllMetadataFailure, (state, {error}) =>
                                            ({...state,
                                              loading: false,
                                              success: false,
                                              error })),

  on(MetadataActions.loadSingleMetadata, (state) => ({...state, loading: true })),

  on(MetadataActions.loadSingleMetadataSuccess, (state, {data}) =>
          adapter.upsertOne(data, { ...state, success: true,
                                              loading: false,
                                              error: null })),

  on(MetadataActions.loadSingleMetadataFailure, (state, {error}) =>
                                            ({...state,
                                              loading: false,
                                              success: false,
                                              error })),
);

export function metadataReducer(state: MetadataState | undefined, action: Action) {
  return Reducer(state, action);
}
